const MANUAL_OPPORTUNITY_ID_PREFIX = 'manual-';

export const isManualOpportunityId = (id) => typeof id === 'string' && id.startsWith(MANUAL_OPPORTUNITY_ID_PREFIX);

export const isHttpUrl = (value) => {
  if (typeof value !== 'string') return false;
  try {
    const { protocol } = new URL(value.trim());
    return protocol === 'http:' || protocol === 'https:';
  } catch {
    return false;
  }
};
